import * as Sentry from "@sentry/react";

export function initSentry() {
  if (!import.meta.env.PROD) {
    return;
  }

  Sentry.init({
    dsn: "https://76b11754fd7c8497904eb1f8b1806154@o4508660105740288.ingest.us.sentry.io/4508660107706368",
    tunnel: "https://api.paywithglide.xyz/sentry-tunnel",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
      }),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/api\.paywithglide\.xyz/],
    // Session Replay
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,

    enableLogs: true,
  });
}
